import { createSlice } from "@reduxjs/toolkit";
import { query, describe } from "../../services/salesforce";
import { get } from "../../api";

export const CorporateArtPortalSlice = createSlice({
    // Slice name, this should be always as page name.
    name: "CorporateArtPortal",

    // Initial state for the slice
    initialState: {
        data: {},
        status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
    },

    // Reducers will mutate the state, put all the state mutation method over here
    reducers: {
        initialize: (state, action) => {
            state.data = action.payload;
            state.status = "succeeded";
            state.error = null;
        },
        error: (state, action) => {
            state.status = "failed";
            state.error = action.payload;
        },
        loading: (state, action) => {
            state.status = action.payload ? "loading" : "succeeded";
        },
        initialLoading: (state, action) => {
            state.status = action.payload ? "initalLoading" : "succeeded";
        },
    },
});

export default CorporateArtPortalSlice.reducer;

// Export all the reducers actions here
export const { initialize, error, loading, initialLoading } = CorporateArtPortalSlice.actions;

// Public Selectors
export const selectCorporateArtPortalData = (state) => state.corporateArtPortal.data;
export const selectCorporateArtPortalStatus = (state) => state.corporateArtPortal.status;
export const selectCorporateArtPortalError = (state) => state.corporateArtPortal.error;

export const initializeAsync = (props) => async (dispatch) => {
    dispatch(initialLoading(true));
    const [favouriteResult, opportunityResult] = await Promise.all([
        get("favourite/getFavourite", {
            accountId: props.userDetails?.contact?.accountId,
            contactId: props.userDetails?.contact?.id,
        }),
        get("opportunity/getOrderList", {
            accountId: props.userDetails?.contact?.accountId,
            contactId: props.userDetails?.contact?.id,
        }),
    ]);

    if (favouriteResult.isSuccess || opportunityResult.isSuccess) {
        dispatch(initialize({ data: { favourite: favouriteResult.data, opportunity: opportunityResult.data } }));
    } else {
        dispatch(error(favouriteResult.errorMessage ? favouriteResult.errorMessage : opportunityResult.errorMessage));
    }
};
